import { trimSearch } from '@xmatters/common/utils/searchUtil';

export const GROUP_SELECT = 'GROUP_SELECT';
export const GROUP_SELECT_MANY = 'GROUP_SELECT_MANY';
export const GROUP_UNSELECT = 'GROUP_UNSELECT';
export const CURRENT_GROUP_SET_TIMEZONE = 'CURRENT_GROUP_SET_TIMEZONE';
export const CURRENT_GROUP_SET_HAS_SITE_HOLIDAY =
  'CURRENT_GROUP_SET_HAS_SITE_HOLIDAY';
export const CURRENT_GROUP_SET_UUID = 'CURRENT_GROUP_SET_UUID';

export const GET_GROUP = 'GET_GROUP';
export const GET_GROUP_SUCCESS = `${GET_GROUP}_SUCCESS`;
export const GET_GROUP_FAIL = `${GET_GROUP}_FAIL`;

export const GET_GROUPS = 'GET_GROUPS';
export const GET_GROUPS_SUCCESS = `${GET_GROUPS}_SUCCESS`;
export const GET_GROUPS_FAIL = `${GET_GROUPS}_FAIL`;

export const GROUP_ADD_MEMBER = 'GROUP_ADD_MEMBER';
export const GROUP_ADD_MEMBER_START = `${GROUP_ADD_MEMBER}_START`;
export const GROUP_ADD_MEMBER_SUCCESS = `${GROUP_ADD_MEMBER}_SUCCESS`;
export const GROUP_ADD_MEMBER_FAIL = `${GROUP_ADD_MEMBER}_FAIL`;

export const GROUP_CHANGE_FILTER = 'GROUP_CHANGE_FILTER';
export const GROUP_CHANGE_FILTER_SUCCESS = 'GROUP_CHANGE_FILTER_SUCCESS';
export const GROUP_CREATE = 'GROUP_CREATE';
export const GROUP_CREATE_START = `${GROUP_CREATE}_START`;
export const GROUP_CREATE_SUCCESS = `${GROUP_CREATE}_SUCCESS`;
export const GROUP_CREATE_FAIL = `${GROUP_CREATE}_FAIL`;
export const GROUP_UNSELECT_ALL = 'GROUP_UNSELECT_ALL';
export const GROUP_UNSELECT_MANY = 'GROUP_UNSELECT_MANY';

export function create(payload, type = GROUP_CREATE) {
  return {
    type,
    meta: {
      xmWebApp: true,
      uri: '/webapi/xm/1/groups/',
      method: 'post',
      params: payload,
    },
  };
}

export function addMember(groupName, member, type = GROUP_ADD_MEMBER) {
  return {
    type,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/groups/${groupName}/members`,
      method: 'post',
      params: { id: member },
    },
  };
}

export function select(index, id, includeAll) {
  return {
    type: GROUP_SELECT,
    payload: {
      index,
      id,
      includeAll,
    },
  };
}

export function selectMany(groups) {
  return {
    type: GROUP_SELECT_MANY,
    payload: {
      groups,
    },
  };
}

export function unselect(id) {
  return {
    type: GROUP_UNSELECT,
    payload: {
      id,
    },
  };
}

export function unSelectAll() {
  return {
    type: GROUP_UNSELECT_ALL,
  };
}

export function unSelectMany(groups) {
  return {
    type: GROUP_UNSELECT_MANY,
    payload: {
      groups,
    },
  };
}

export function getOne(groupId) {
  return {
    type: GET_GROUP,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/groups/${groupId}`,
      method: 'get',
    },
  };
}

export function get({
  startIndex,
  stopIndex,
  searchText,
  supervised,
  supervisorId,
  groupType,
  fields,
  action = GET_GROUPS,
}) {
  let limit = stopIndex - startIndex;
  limit = limit === 0 ? 1 : limit;
  const params = {
    limit,
    offset: startIndex,
    status: 'ACTIVE',
  };
  const trimmedSearchText = trimSearch(searchText);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
    if (fields) {
      params.fields = fields;
    }
  }
  if (supervised) {
    params.supervisor = supervisorId;
  }
  if (groupType) {
    params.groupType = groupType;
  }
  return {
    type: action,
    startIndex,
    meta: {
      params,
      xmApi: true,
      uri: '/webapi/xm/1/groups',
      method: 'get',
    },
  };
}

export function changeFilter({
  startIndex,
  stopIndex,
  searchText,
  supervised,
  supervisorId,
  groupType,
  fields,
}) {
  return get({
    startIndex,
    stopIndex,
    searchText,
    supervised,
    supervisorId,
    groupType,
    fields,
    action: GROUP_CHANGE_FILTER,
  });
}

export const GET_GROUP_MEMBERS = 'GET_GROUP_MEMBERS';
export const GET_GROUP_MEMBERS_START = `${GET_GROUP_MEMBERS}_START`;
export const GET_GROUP_MEMBERS_SUCCESS = `${GET_GROUP_MEMBERS}_SUCCESS`;
export const GET_GROUP_MEMBERS_FAIL = `${GET_GROUP_MEMBERS}_FAIL`;

export function getGroupMembers({ startIndex, groupId, sortBy, sortOrder }) {
  const sortOptions = {
    name: 'NAME',
  };

  return {
    type: GET_GROUP_MEMBERS,
    startIndex,
    meta: {
      params: {
        offset: startIndex,
        sortBy: sortOptions[sortBy] || sortOptions.name,
        sortOrder,
      },
      xmApi: true,
      uri: `/webapi/xm/1/groups/${groupId}/members`,
      method: 'get',
    },
  };
}

export const ADD_GROUP_MEMBERS_DIALOG_OPEN = 'ADD_GROUP_MEMBERS_DIALOG_OPEN';
export const ADD_GROUP_MEMBERS_DIALOG_CLOSE = 'ADD_GROUP_MEMBERS_DIALOG_CLOSE';

export function openAddGroupMembersDialog() {
  return {
    type: ADD_GROUP_MEMBERS_DIALOG_OPEN,
  };
}

export function closeAddGroupMembersDialog() {
  return {
    type: ADD_GROUP_MEMBERS_DIALOG_CLOSE,
  };
}
export const MANAGE_OBSERVERS_DIALOG_OPEN = 'MANAGE_OBSERVERS_DIALOG_OPEN';
export const MANAGE_OBSERVERS_DIALOG_CLOSE = 'MANAGE_OBSERVERS_DIALOG_CLOSE';

export function openManageObserversDialog() {
  return {
    type: MANAGE_OBSERVERS_DIALOG_OPEN,
  };
}

export function closeManageObserversDialog() {
  return {
    type: MANAGE_OBSERVERS_DIALOG_CLOSE,
  };
}

export function setCurrentGroupUuid(uuid) {
  return {
    type: CURRENT_GROUP_SET_UUID,
    payload: uuid,
  };
}

export function setCurrentGroupTimezone(timezone, timezoneLabel) {
  return {
    type: CURRENT_GROUP_SET_TIMEZONE,
    payload: {
      timezone,
      timezoneLabel,
    },
  };
}

export const WHOS_ON_CALL_DIALOG_OPEN = 'WHOS_ON_CALL_DIALOG_OPEN';
export const WHOS_ON_CALL_DIALOG_CLOSE = 'WHOS_ON_CALL_DIALOG_CLOSE';

export function openWhosOnCallDialog({ group, history, start, end }) {
  return {
    type: WHOS_ON_CALL_DIALOG_OPEN,
    payload: {
      group,
      history,
      start,
      end,
    },
  };
}

export function closeWhosOnCallDialog() {
  return {
    type: WHOS_ON_CALL_DIALOG_CLOSE,
  };
}

// Groups are objects (not arrays) with the following format:
// { 0: {group1}, 1: {group2} } - which means the logic required
// to manipulate their values looks a little silly.
export function concatGroups(originalGroups, newGroups) {
  const originalUuids = Object.keys(originalGroups).map(
    k => originalGroups[k].id,
  );
  const newUniqueUuids = Object.keys(newGroups)
    .map(k => newGroups[k].id)
    .filter(k => !originalUuids.includes(k));

  const newUniqueGroups = {};
  newUniqueUuids.forEach((uniqueUuid, i) => {
    const newGroupIndex = Object.keys(newGroups).find(
      k => newGroups[k].id === uniqueUuid,
    );
    newUniqueGroups[i] = newGroups[newGroupIndex];
  });

  const originalGroupsLength = Object.keys(originalGroups).length;

  const ret = { ...originalGroups };
  Object.keys(newUniqueGroups).forEach((g, i) => {
    ret[originalGroupsLength + i] = { ...newUniqueGroups[g] };
  });

  return ret;
}

export function reindexGroups(groups) {
  const ret = {};
  Object.keys(groups).forEach((k, i) => {
    ret[i] = { ...groups[k] };
  });

  return ret;
}
